module.exports = __webpack_public_path__ + "img/logo.7a904692.png";